import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const ImportRoleIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z"
                fill="none"
                stroke={props.htmlColor || '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3 9H21"
                stroke={props.htmlColor || '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M8.56934 18H7.82227V14.4014H8.56934V18Z" fill={props.htmlColor || '#21272E'} />
            <path
                d="M11.6577 14.4014H12.7393V18H12.0386V15.5659C12.0386 15.4959 12.0394 15.3983 12.041 15.273C12.0426 15.146 12.0435 15.0484 12.0435 14.98L11.3623 18H10.6323L9.95605 14.98C9.95605 15.0484 9.95687 15.146 9.9585 15.273C9.96012 15.3983 9.96094 15.4959 9.96094 15.5659V18H9.26025V14.4014H10.354L11.0083 17.231L11.6577 14.4014Z"
                fill={props.htmlColor || '#21272E'}
            />
            <path
                d="M15.4639 15.5464C15.4639 15.3592 15.4142 15.2258 15.3149 15.146C15.2173 15.0663 15.0798 15.0264 14.9023 15.0264H14.2017V16.086H14.9023C15.0798 16.086 15.2173 16.0428 15.3149 15.9566C15.4142 15.8703 15.4639 15.7336 15.4639 15.5464ZM16.2085 15.5415C16.2085 15.9663 16.1011 16.2666 15.8862 16.4424C15.6714 16.6182 15.3646 16.7061 14.9658 16.7061H14.2017V18H13.4546V14.4014H15.022C15.3833 14.4014 15.6714 14.4942 15.8862 14.6797C16.1011 14.8652 16.2085 15.1525 16.2085 15.5415Z"
                fill={props.htmlColor || '#21272E'}
            />
            <path d="M16.0596 17.2725H16.7993V18H16.0596V17.2725Z" fill={props.htmlColor || '#21272E'} />
        </SvgIcon>
    );
};
